module.exports = __webpack_public_path__ + "img/ЗВ-13(КВ)-008.448f9443.png";